/**
 * Credentials - Shows and hides the form fields relevant to the currently selected credential types
 */
$(document).ready(function () {
    $('#credential_type').change(function (el) {
        $('[data-credential-type]').hide();
        $('[data-credential-type="' + el.target.value + '"]').show();
    });
});
